export default function Subscribe() {
  return (
    <>
      <div className=" bg-[#024273] px-4 py-12 md:px-20">
        <div className="bg-[#024273] shadow-2xl px-6 sm:px-32 py-16 lg:flex lg:items-center lg:justify-between ">
          <h2 className="text-white basis-1/4 text-2xl sm:text-3xl  font-semibold">
            Subscribe Newsletters
          </h2>
          <div className=" basis-1/2 w-full lg:w-auto flex flex-col sm:flex-row items-center justify-center gap-y-2 sm:gap-y-0 ">
            <input
              type="email"
              className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-l-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              placeholder="Enter your email"
            />
            <button className="px-6 py-2 text-white bg-[#024273]  border-2 border-white  w-[auto] hover:bg-[#102230] focus:ring-4 focus:ring-blue-300 font-medium rounded-r-md text-sm whitespace-nowrap">
              Subscribe Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
